// extracted by mini-css-extract-plugin
module.exports = {"boldText":"range-estimation-desktop_boldText__4vuM0","descriptionText":"range-estimation-desktop_descriptionText__09ohi","footerText":"range-estimation-desktop_footerText__V1mbn"};